import * as React from 'react';
import { WebDate } from "../../WebDate";
import * as main from '../../../styles/main.module.scss';
import * as form from './form.module.scss';

export const Form = ({ widget, staticDate }) => {
  return (
    <section className={form.form}>
      <div className={"container"}>
        <div className={form.form__container}>
          <div className={form.form__info}>
            <h2 className={main.mainTitle}>
              Запишитесь на вебинар<br/>
              и получите ответы<br/>
              на ваши вопросы
            </h2>
            <p className={form.form__date}>{ staticDate || <WebDate/> }</p>
          </div>
          <div className={form.form__widget} id={"widget"}>
            {widget}
          </div>
        </div>
      </div>
    </section>
  );
};
